import React from 'react';

import {getSharedSmartChipProps, SharedSmartChipProps} from 'ui-library/chips/ChipUtil';
import {apiIdToIconName} from 'util/APIUtil';

import SmartChip from './SmartChip';
import useSmartChipQuery, {SmartChipType} from './useSmartChipQuery';

export default function ScratchPlateChip(
  props: SharedSmartChipProps<SmartChipType.SCRATCH_PLATE>
): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;

  const {
    item: scratchPlate,
    handleClickLink,
    isInaccessible,
  } = useSmartChipQuery<SmartChipType.SCRATCH_PLATE>({
    id,
    onClick,
  });

  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={scratchPlate != null ? apiIdToIconName(scratchPlate.id) : null}
      isInaccessible={isInaccessible}
      item={scratchPlate}
      onClick={handleClickLink}
      url={null}
    />
  );
}
